import React from 'react';

import { useAppDispatch, useAppSelector } from 'store';
import {
  loadAttractionsList,
  saveAttractionItem,
} from 'store/slices/attractions/actions';
import { IAttractionItem } from 'store/slices/attractions/interfaces';
import { PageTitles } from 'constants/pageTitles';
import { SampleList } from 'components/Sample/SampleList';

interface IProps {
  sortFieldName?: keyof Pick<
    IAttractionItem,
    'sortPriority' | 'sortPriorityMainPage'
  >;
  limit?: number;
  addON?: boolean;
  deleteON?: boolean;
  isSortPriority?: boolean | null;
}

export const List: React.FC<IProps> = ({
  sortFieldName = 'sortPriority',
  limit,
  addON,
  deleteON,
  isSortPriority = true,
}) => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(state => state.attractions);

  const tableData = data.list.map(item => ({
    title: item.name,
    id: item.id,
    sortPriority: item[sortFieldName],
    image: item.image,
    address: item.address,
  }));

  const handleRemove = async (id: number): Promise<any> => {
    return dispatch(
      saveAttractionItem({
        id,
        [sortFieldName]: null,
      })
    ).unwrap();
  };

  const handleLoadData = (lang: string) => {
    dispatch(
      loadAttractionsList({
        lang: lang,
        limit,
        sort: sortFieldName,
        isSortPriority,
      })
    );
  };

  return (
    <SampleList
      data={tableData}
      handleLoadData={handleLoadData}
      handleDelete={handleRemove}
      isLoading={data.isLoading}
      title={PageTitles.attractions}
      limit={limit}
      addON={addON}
      deleteON={deleteON}
    />
  );
};
